import { IColors } from '@/common/models/ISidebar';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_LOADS } from '@/common/constants';

interface IProps {
  tab: IColors;
}

export function LoadNavbarItem({ tab }: IProps) {
  const { t } = useTranslation();
  const { status } = useParams();
  const navigate = useNavigate();
  return (
    <Button
      variant="ghost"
      className={cn(
        'relative flex items-center border  rounded-lg py-2 px-3 gap-2 font-medium duration-300 ',
        tab?.key === status
          ? 'border-gray-300 bg-gray-50 hover:bg-gray-50 '
          : 'border-transparent hover:bg-transparent',
      )}
      onClick={() => navigate(`${ROUTE_LOADS}/${tab.key}`)}
    >
      <span
        className={cn(
          'whitespace-nowrap text-sm',
          tab ? 'text-black' : 'text-gray-900',
        )}
      >
        {t(tab.name)}
      </span>
    </Button>
  );
}
